<div class="modal-dialog copy-activities-dialog-container">
	<div class="modal-content" cdkTrapFocus>
		<div class="goreact-modal-header">
			<h4 class="modal-title" translate="modal-course-setup_title"></h4>
			<button type="button" class="close-btn" (click)="cancel()" [attr.aria-label]="'common_close' | translate">
				<i class="ficon-app-x"></i>
			</button>
		</div>
		<div class="goreact-modal-body" #content>
			<ng-container [formGroup]="form">
				<mat-radio-group color="primary" formControlName="shouldCopy">
					<mat-radio-button [value]="false">{{'modal-course-setup_start-with-blank-course' | translate }}</mat-radio-button>
					<mat-radio-button [value]="true">{{'modal-course-setup_copy-activities-from-existing-course' | translate }}</mat-radio-button>
				</mat-radio-group>
				<mat-form-field appearance="outline" *ngIf="form.controls.shouldCopy.value">
					<mat-select
						formControlName="folder"
						id="folder-selector"
						disableOptionCentering
						panelClass="offsetPanel">
						<mat-option *ngFor="let folder of data.availableFolders" [value]="folder.group_id">
							{{ folder.name }}
						</mat-option>
					</mat-select>
					<span class="dropdown-arrow"><i class="ficon-app-chevron-down"></i></span>
					<mat-error *ngIf="form.controls.folder.hasError('required')">{{'modal-course-setup_courses-dropdown-error-text' | translate}}</mat-error>
				</mat-form-field>
			</ng-container>
		</div>
		<div class="goreact-modal-footer">
			<button
				class="confirm-button primary-btn"
				(click)="confirm()"
				[focusOnFirstInvalidField]="{formGroup: form, formWrapper: content}"
				translate="common_continue">
			</button>
		</div>
	</div>
</div>
